import type { Extractor } from "../types.js";

export const extractNan: Extractor = () => ({ type: "nan" });
